// Modelo Anamnesis BDD
export default class PatientHealthAndJob {
    id=""
    date=""
    value=""
    patientRouteSheet=""
}



// WEBPACK FOOTER //
// ./src/model/PatientHealthAndJob.js